declare namespace $ {

	export class $mol_icon_fuel extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=fuel.view.tree.d.ts.map